import React, { useState } from 'react';
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTheme } from '../../hooks/useTheme';

const HeroCarousel = () => {
  const { backgroundStyles, hasBackground } = useTheme();
  
  const items = [
    { src: '/assets/images/c1.png', caption: 'Grow your business' },
    { src: '/assets/images/c2.png', caption: 'Drive Campaigns' },
    { src: '/assets/images/c3.png', caption: 'Automate Workflow' },
    { src: '/assets/images/c4.png', caption: 'Manage leads' },
  ];

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div 
      className={`hero-carousel-fullwidth ${hasBackground() ? 'has-background' : 'no-background'}`}
      style={hasBackground() ? backgroundStyles : {}}
    >
      <div className="my-5 text-center container">
        <Carousel activeIndex={index} onSelect={handleSelect} interval={1500}>
          {items.map((item, idx) => (
            <Carousel.Item key={idx}>
              <img
                className="d-block mx-auto img-fluid"
                src={item.src}
                alt={item.caption}
                style={{ borderRadius: '10px' }}
              />
            </Carousel.Item>
          ))}
        </Carousel>

        {/* Caption below carousel */}
        <div className="mt-3">
          <h5>{items[index].caption}</h5>
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;
